import React, { useState } from 'react'; // Import useState for managing component state
import '../css/NavigationBar.css'; // Importing CSS for styling the About Us page
import { IoMenu } from "react-icons/io5"; // Importing a menu icon from react-icons
import { Link } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import { IoMdLogOut } from "react-icons/io";
import { BsGraphUpArrow } from "react-icons/bs";
const ProfileNavBar = () => {
    // State to handle the visibility of the menu items
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    // Function to toggle menu visibility
    const toggleMenu = () => {
        setIsMenuVisible(!isMenuVisible); // Toggle the state from true to false and vice versa
    };

    const handleLogout = () => {
        sessionStorage.removeItem('user'); // Remove user data from session storage
        window.location.href = '/'; // Redirect to the home page
    }
    const handleProfile = () => {
        window.location.href = '/profile'; // Redirect to the profile page
    }

    return (
        <div>
            <div className="parentnavbar"> {/* Main container for the navbar */}
                <div className='logo'>
                    <img className='logoimg' src='/images/ft_logo.png' alt='logo'></img>
                </div>
                <div className='bar'>
                    
                        <Link to="/" >Home</Link>
                        <Link to="/bmicalculator">BMI Calculator</Link>
                    <Link  to="/analytics">Analytics</Link>  
                    <Link to="/progressDashboard">Dashboard</Link>
                    <Link to="/activitylogging">Activity Logging</Link>
                     <CgProfile className='iconp' onClick={handleProfile}/> &nbsp;
                    <IoMdLogOut className='iconp' onClick={handleLogout}/>

                </div>
            </div>
            <div className='mobileparentnavbar'>
                <div className='mobilebar'>
                    <IoMenu onClick={toggleMenu} /> {/* Menu icon with click handler */}
                    {/* Conditional rendering of menu items based on isMenuVisible */}
                    {isMenuVisible && (
                        <div className='menuitems'>
                            <button className='button'>
                                <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>Home</Link>
                            </button>
                            <Link to="/analytics">Analytics</Link>

                            <Link to ="/progressDashboard">Dashboard</Link>
                            <Link to = "/activitylogging">Activity Logging</Link>
                            <button className='button'>Profile</button>
                            <Link to = "/">Logout</Link>
                        </div>
                    )}
                </div>
                <div className='mobilelogo'>
                    <img className='logoimg' src='/images/ft_logo.png' alt='logo'></img>
                </div>
            </div>
        </div>
    );
};

export default ProfileNavBar; // Exporting the Navbar component for use in other parts of the application
